module.exports = __webpack_public_path__ + "static/media/vehicle-behaviour.11296cf1.svg";